import Reportes from "../components/Reportes/Reportes";
import ReporteDxSemana from "../components/Reportes/ReporteDxSemana";
import ReporteDxMensual from "../components/Reportes/ReporteDxMensual";
import ReporteDxAnual from "../components/Reportes/ReporteDxAnual";
import GenerarDxMensual from "../components/Reportes/GenerarDxMensual";
import GenerarDxSemana from "../components/Reportes/GenerarDxSemana";
import GenerarDxAnual from "../components/Reportes/GenerarDxAnual";

export const ReportesRoutes = [
    { path: '/caracterizacion/reportes', element: <Reportes /> },
    { path: '/caracterizacion/reportesemana/:id', element: <ReporteDxSemana /> },
    { path: '/caracterizacion/reportemensual/:id', element: <ReporteDxMensual /> },
    { path: '/caracterizacion/reporteanual/:id', element: <ReporteDxAnual /> },
    { path: '/caracterizacion/generarreportemensual/:id', element: <GenerarDxMensual /> },
    { path: '/caracterizacion/generarreportesemana/:id', element: <GenerarDxSemana /> },
    { path: '/caracterizacion/generarreporteanual/:id', element: <GenerarDxAnual /> },
];